module.exports = __webpack_public_path__ + "static/inconsolata-regular-webfont-7b35acc15d49262f9d57e071dc4d1f77.woff2";